// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { FaPython, FaDatabase, FaRobot, FaGraduationCap, FaLightbulb, FaBriefcase, FaBook } from "react-icons/fa";

// const Aiml = () => {
//   useEffect(() => { AOS.init({ duration: 1200, once: true }); }, []);
//   const [faqOpen, setFaqOpen] = useState(Array(3).fill(false));
//   const toggleFaq = (idx) => { const newState = [...faqOpen]; newState[idx] = !newState[idx]; setFaqOpen(newState); };

//   const syllabus = [
//     { title: "Module 1: AI & ML Fundamentals", topics: ["Introduction to AI & ML", "Types of ML", "Mathematics for ML", "Python for AI", "Problem Solving Techniques"] },
//     { title: "Module 2: Supervised Learning", topics: ["Linear & Logistic Regression", "Decision Trees", "Random Forests", "SVM", "Model Evaluation"] },
//     { title: "Module 3: Unsupervised Learning", topics: ["Clustering Methods", "PCA & Dimensionality Reduction", "Anomaly Detection", "Association Rules", "Hands-on Projects"] },
//     { title: "Module 4: Advanced AI Topics", topics: ["Neural Networks Basics", "Deep Learning Introduction", "Natural Language Processing", "Model Deployment", "AI Ethics"] }
//   ];

//   const tools = [
//     { icon: <FaPython color="#3776AB" />, name: "Python" },
//     { icon: <FaDatabase color="#f29111" />, name: "SQL" },
//     { icon: <FaRobot color="#845ef7" />, name: "TensorFlow" },
//     { icon: <FaRobot color="#ff6b6b" />, name: "Keras" },
//     { icon: <FaPython color="#22b8cf" />, name: "PyTorch" }
//   ];

//   const learners = [
//     { icon: <FaGraduationCap color="#6a11cb" />, name: "Students" },
//     { icon: <FaBriefcase color="#2575fc" />, name: "Professionals" },
//     { icon: <FaLightbulb color="#ff6b6b" />, name: "AI Enthusiasts" },
//     { icon: <FaGraduationCap color="#ff922b" />, name: "Researchers" },
//     { icon: <FaLightbulb color="#20c997" />, name: "Career Changers" }
//   ];

//   const careers = [
//     { icon: <FaBriefcase color="#6a11cb" />, title: "AI Engineer", desc: "Build intelligent systems using AI & ML algorithms." },
//     { icon: <FaBriefcase color="#2575fc" />, title: "ML Engineer", desc: "Develop predictive models and pipelines." },
//     { icon: <FaBriefcase color="#ff6b6b" />, title: "Data Scientist", desc: "Analyze and interpret complex datasets." },
//     { icon: <FaBriefcase color="#ff922b" />, title: "Research Scientist", desc: "Work on advanced AI & ML research projects." },
//     { icon: <FaBriefcase color="#20c997" />, title: "AI Consultant", desc: "Advise organizations on AI strategies." },
//     { icon: <FaBriefcase color="#845ef7" />, title: "AI Product Manager", desc: "Lead AI-driven product development." }
//   ];

//   const outcomes = [
//     { icon: <FaBook color="#2575fc" />, title: "Understand AI Concepts", desc: "Grasp core AI & ML theories." },
//     { icon: <FaBook color="#ff6b6b" />, title: "Model Building", desc: "Develop supervised and unsupervised models." },
//     { icon: <FaBook color="#20c997" />, title: "Deep Learning", desc: "Work with neural networks and advanced AI models." },
//     { icon: <FaBook color="#845ef7" />, title: "Data Handling", desc: "Process large datasets efficiently." },
//     { icon: <FaBook color="#ff922b" />, title: "Deployment", desc: "Deploy ML models in real-world applications." },
//     { icon: <FaBook color="#6a11cb" />, title: "Hands-on Projects", desc: "Apply knowledge in practical AI projects." }
//   ];

//   const faq = [
//     { question: "Do I need prior programming experience?", answer: "Basic Python knowledge is recommended but not mandatory." },
//     { question: "Which tools will I learn?", answer: "Python, SQL, TensorFlow, Keras, PyTorch." },
//     { question: "Is this course suitable for beginners?", answer: "Yes, the course starts with fundamentals and progresses to advanced topics." }
//   ];

//   return (
//     <div>
//       <style>{`
//         body { font-family:'Poppins',sans-serif;margin:0;padding:0;background:#f0f2f5;color:#333; }
//         .container { width:90%; max-width:1200px; margin:auto; padding:2rem 0; }
//         .hero-section { background-image:url('https://media.istockphoto.com/id/966248982/photo/robot-with-education-hud.jpg?s=612x612&w=0&k=20&c=9eoZYRXNZsuU3edU87PksxN4Us-c9rB6IR7U_IGZ-U8='); background-size:cover; background-position:center; color:#fff; text-align:center; padding:6rem 1rem; position:relative; }
//         .hero-section::before { content:""; position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); }
//         .hero-section .container { position:relative; z-index:1; }
//         .hero-section h1 { font-size:3rem; margin-bottom:1rem; }
//         .hero-section p { font-size:1.2rem; margin-bottom:2rem; }
//         .btn { display:inline-block; background:#ff6b6b; color:#fff; padding:0.8rem 2rem; border-radius:30px; text-decoration:none; font-weight:600; transition:0.3s; }
//         .btn:hover { background:#ff4757; transform:scale(1.05); }

//         section h2 { text-align:center; color:#111; font-size:2.5rem; margin-bottom:2rem; }

//         .about-course { display:flex; flex-direction:column; align-items:center; gap:2rem; text-align:center; }
//         .about-course img { width:100%; max-width:600px; border-radius:15px; box-shadow:0 10px 30px rgba(0,0,0,0.1); }
//         .about-course p { max-width:800px; line-height:1.6; font-size:1.1rem; }

//         .syllabus-cards, .tools-cards, .learners-cards, .careers-cards { display:grid; gap:1rem; }
//         .syllabus-cards { grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
//         .tools-cards, .learners-cards { grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); }
//         .careers-cards { grid-template-columns: repeat(3,1fr); grid-auto-rows:1fr; }

//         .module-card, .card, .outcome-card { background:#fdf6f0; border-radius:15px; padding:1.5rem; box-shadow:0 8px 20px rgba(0,0,0,0.1); text-align:center; transition:transform 0.3s, box-shadow 0.3s; display:flex; flex-direction:column; align-items:center; justify-content:center; }
//         .module-card:hover, .card:hover, .outcome-card:hover { transform:translateY(-8px) scale(1.02); box-shadow:0 15px 25px rgba(0,0,0,0.2); }
//         .module-card h3, .card h3, .outcome-card h3 { margin-bottom:1rem; }
//         .module-card ul { list-style:disc; padding-left:1.5rem; text-align:left; font-size:0.95rem; }

//         .card div { animation:bounce 2s infinite; }
//         @keyframes bounce { 0%,100%{ transform: translateY(0); } 50%{ transform: translateY(-10px); } }

//         /* Learning Outcomes Section */
// .learning-outcomes {
//   text-align: center;   /* Center everything inside */
//   padding: 2rem 1rem;
// }

// .learning-outcomes h2 {
//   font-size: 2.5rem;
//   margin-bottom: 2rem;
//   color: #111;
// }

// /* Continuous Marquee (Left to Right) */
// .outcomes-marquee {
//   overflow: hidden;
//   width: 100%;
//   position: relative;
// }

// .marquee-track {
//   display: flex;
//   gap: 1rem;
//   animation: marqueeLTR 25s linear infinite;
// }

// .marquee-track:hover {
//   animation-play-state: paused;
// }

// .outcome-card {
//   min-width: 220px;
//   flex-shrink: 0;
//   background: #fdf6f0;
//   border-radius: 15px;
//   padding: 1rem;
//   box-shadow: 0 8px 20px rgba(0,0,0,0.1);
//   text-align: center;
//   transition: transform 0.3s, box-shadow 0.3s;
// }

// .outcome-card:hover {
//   transform: translateY(-5px) scale(1.03);
//   box-shadow: 0 12px 25px rgba(0,0,0,0.15);
// }

// /* Animate from left to right */
// @keyframes marqueeLTR {
//   0% { transform: translateX(100%); }
//   100% { transform: translateX(-100%); }
// }

//         .faq-card { background:#fff; padding:1rem; border-radius:15px; box-shadow:0 6px 15px rgba(0,0,0,0.1); margin-bottom:1rem; cursor:pointer; transition:0.3s; }
//         .faq-card:hover { transform:translateY(-3px); box-shadow:0 10px 20px rgba(0,0,0,0.15); }
//         .faq-answer { max-height:0; overflow:hidden; transition:max-height 0.3s ease; }
//         .faq-answer.open { max-height:200px; margin-top:0.5rem; }

//         footer { background:#111; color:#fff; padding:3rem 1rem; text-align:center; }
//         footer a { color:#ff6b6b; text-decoration:none; transition:0.3s; }
//         footer a:hover { text-decoration:underline; }
//       `}</style>

//       {/* Hero */}
//       <header className="hero-section" data-aos="fade-down">
//         <div className="container">
//           <h1>AI & ML Mastery</h1>
//           <p>Master artificial intelligence and machine learning techniques for real-world applications</p>
//           <a href="/contact" className="btn">Enroll Now</a>
//         </div>
//       </header>

//       {/* About */}
//       <section className="about-course mt-5" data-aos="fade-up">
//         <h2>About AI & ML Course</h2>
//         <img src="https://theromanianlawyers.com/wp-content/uploads/2023/02/AI.jpeg" alt="AI & ML" />
//         <p>Learn AI & ML concepts, algorithms, and tools. Gain hands-on experience with Python, TensorFlow, Keras, and PyTorch to build intelligent models and solve real-world problems.</p>
//       </section>

//       {/* Syllabus */}
//       <section className="course-syllabus" data-aos="fade-up">
//         <div className="container">
//           <h2>Course Syllabus</h2>
//           <div className="syllabus-cards animate-float">
//             {syllabus.map((mod,idx)=>(
//               <div className="module-card" key={idx} data-aos="zoom-in" data-aos-delay={idx*100}>
//                 <h3>{mod.title}</h3>
//                 <ul>{mod.topics.map((t,i)=><li key={i}>{t}</li>)}</ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Tools */}
//       <section className="tools-technologies" data-aos="fade-up">
//         <div className="container">
//           <h2>Tools & Technologies</h2>
//           <div className="tools-cards animate-bounce-hover">
//             {tools.map((tool,idx)=>(
//               <div className="card" key={idx} data-aos="flip-left" data-aos-delay={idx*50}>
//                 <div style={{fontSize:"2rem", marginBottom:"10px"}}>{tool.icon}</div>
//                 <h3>{tool.name}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Learners */}
//       <section className="who-can-enroll" data-aos="fade-up">
//         <div className="container">
//           <h2>Who Can Enroll</h2>
//           <div className="learners-cards animate-bounce-slow">
//             {learners.map((learner,idx)=>(
//               <div className="card" key={idx} data-aos="fade-right" data-aos-delay={idx*50}>
//                 <div style={{fontSize:"2rem", marginBottom:"10px"}}>{learner.icon}</div>
//                 <h3>{learner.name}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Careers */}
//       <section className="career-opportunities" data-aos="fade-up">
//         <div className="container">
//           <h2>Career Opportunities</h2>
//           <div className="careers-cards">
//             {careers.map((career,idx)=>(
//               <div className="card animate-float" key={idx} data-aos="fade-left" data-aos-delay={idx*50}>
//                 <div style={{fontSize:"2rem", marginBottom:"10px"}} className="animate-wiggle">{career.icon}</div>
//                 <h3>{career.title}</h3>
//                 <p>{career.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Outcomes Marquee */}
// <section className="learning-outcomes" data-aos="fade-up">
//   <div className="container">
//     <h2>What You'll Learn</h2>
//     <div className="outcomes-marquee">
//       <div className="marquee-track">
//         {[...outcomes, ...outcomes].map((o, idx) => (
//           <div className="outcome-card p-5" key={idx}>
//             <div style={{ fontSize: "2rem", marginBottom: "5px" }} className="animate-wiggle">{o.icon}</div>
//             <h3 className="pt-2">{o.title}</h3>
//             <p>{o.desc}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// </section>

//       {/* FAQ */}
//       <section className="faq-section" data-aos="fade-up" style={{padding:"4rem 1rem"}}>
//         <div className="container">
//           <h2>Frequently Asked Questions</h2>
//           {faq.map((q,idx)=>(
//             <div key={idx} className="faq-card" onClick={()=>toggleFaq(idx)}>
//               <h3>{q.question}</h3>
//               <div className={`faq-answer ${faqOpen[idx]?"open":""}`}>
//                 <p>{q.answer}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Footer */}
//       <footer>
//         <div className="container">
//           <h2>Enroll Now to Kickstart Your AI & ML Career</h2>
//           <p>Join our comprehensive AI & ML program and gain hands-on experience with real-world projects.</p>
//           <a href="#enroll" className="btn">Enroll Now</a>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Aiml;

import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaPython,
  FaDatabase,
  FaRobot,
  FaGraduationCap,
  FaLightbulb,
  FaBriefcase,
  FaBook,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Aiml = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const [faqOpen, setFaqOpen] = useState(Array(3).fill(false));
  const toggleFaq = (idx) => {
    const newState = [...faqOpen];
    newState[idx] = !newState[idx];
    setFaqOpen(newState);
  };

  const syllabusColors = ["#FFEDD5", "#D1FAE5", "#DBEAFE", "#FCE7F3"];
  const toolColors = ["#E0F2FE", "#FEE2E2", "#E9D5FF", "#DCFCE7", "#FFF7ED"];
  const learnerColors = ["#FEF3C7", "#D1FAE5", "#DBEAFE", "#FCE7F3", "#E0F2FE"];
  const careerColors = [
    "#FDE68A",
    "#A7F3D0",
    "#BFDBFE",
    "#F9A8D4",
    "#A5F3FC",
    "#E0AAFF",
  ];
  const faqColors = ["#fff", "#f3f4f6", "#fff"];

  const syllabus = [
    {
      title: "Module 1: AI & ML Fundamentals",
      topics: [
        "Introduction to AI & ML",
        "Types of ML",
        "Mathematics for ML",
        "Python for AI",
        "Problem Solving Techniques",
      ],
    },
    {
      title: "Module 2: Supervised Learning",
      topics: [
        "Linear & Logistic Regression",
        "Decision Trees",
        "Random Forests",
        "SVM",
        "Model Evaluation",
      ],
    },
    {
      title: "Module 3: Unsupervised Learning",
      topics: [
        "Clustering Methods",
        "PCA & Dimensionality Reduction",
        "Anomaly Detection",
        "Association Rules",
        "Hands-on Projects",
      ],
    },
    {
      title: "Module 4: Advanced AI Topics",
      topics: [
        "Neural Networks Basics",
        "Deep Learning Introduction",
        "Natural Language Processing",
        "Model Deployment",
        "AI Ethics",
      ],
    },
  ];

  const tools = [
    { icon: <FaPython color="#3776AB" />, name: "Python" },
    { icon: <FaDatabase color="#f29111" />, name: "SQL" },
    { icon: <FaRobot color="#845ef7" />, name: "TensorFlow" },
    { icon: <FaRobot color="#ff6b6b" />, name: "Keras" },
  ];

  const learners = [
    { icon: <FaGraduationCap color="#6a11cb" />, name: "Students" },
    { icon: <FaBriefcase color="#2575fc" />, name: "Professionals" },
    { icon: <FaLightbulb color="#ff6b6b" />, name: "AI Enthusiasts" },
    { icon: <FaGraduationCap color="#ff922b" />, name: "Researchers" },
  ];

  const careers = [
    {
      icon: <FaBriefcase color="#6a11cb" />,
      title: "AI Engineer",
      desc: "Build intelligent systems using AI & ML algorithms.",
    },
    {
      icon: <FaBriefcase color="#2575fc" />,
      title: "ML Engineer",
      desc: "Develop predictive models and pipelines.",
    },
    {
      icon: <FaBriefcase color="#ff6b6b" />,
      title: "Data Scientist",
      desc: "Analyze and interpret complex datasets.",
    },
    {
      icon: <FaBriefcase color="#ff922b" />,
      title: "Research Scientist",
      desc: "Work on advanced AI & ML research projects.",
    },
    {
      icon: <FaBriefcase color="#20c997" />,
      title: "AI Consultant",
      desc: "Advise organizations on AI strategies.",
    },
    {
      icon: <FaBriefcase color="#845ef7" />,
      title: "AI Product Manager",
      desc: "Lead AI-driven product development.",
    },
  ];

  const outcomes = [
    {
      icon: <FaBook color="#2575fc" />,
      title: "Understand AI Concepts",
      desc: "Grasp core AI & ML theories.",
    },
    {
      icon: <FaBook color="#ff6b6b" />,
      title: "Model Building",
      desc: "Develop supervised and unsupervised models.",
    },
    {
      icon: <FaBook color="#20c997" />,
      title: "Deep Learning",
      desc: "Work with neural networks and advanced AI models.",
    },
    {
      icon: <FaBook color="#6a11cb" />,
      title: "Hands-on Projects",
      desc: "Apply knowledge in practical AI projects.",
    },
    {
      icon: <FaBook color="#ff922b" />,
      title: "Deployment",
      desc: "Deploy ML models in real-world applications.",
    },
  ];

  const faq = [
    {
      question: "Do I need prior programming experience?",
      answer: "Basic Python knowledge is recommended but not mandatory.",
    },
    {
      question: "Which tools will I learn?",
      answer: "Python, SQL, TensorFlow, Keras, PyTorch.",
    },
    {
      question: "Is this course suitable for beginners?",
      answer:
        "Yes, the course starts with fundamentals and progresses to advanced topics.",
    },
  ];

  return (
    <div className="overflow-hidden">
      <style>{`
        body { font-family:'Poppins',sans-serif; margin:0; padding:0; background:#f0f2f5; color:#333; }
        .container { width:90%; max-width:1200px; margin:auto; padding:2rem 0; }

        .hero-section { background-image:url('https://media.istockphoto.com/id/966248982/photo/robot-with-education-hud.jpg?s=612x612&w=0&k=20&c=9eoZYRXNZsuU3edU87PksxN4Us-c9rB6IR7U_IGZ-U8='); background-size:cover; background-position:center; color:#fff; text-align:center; padding:6rem 1rem; position:relative; }
        .hero-section::before { content:""; position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); }
        .hero-section .container { position:relative; z-index:1; }
        .hero-section h1 { font-size:3rem; margin-bottom:1rem; }
        .hero-section p { font-size:1.2rem; margin-bottom:2rem; }
        .btn { display:inline-block; background:#ff6b6b; color:#fff; padding:0.8rem 2rem; border-radius:30px; text-decoration:none; font-weight:600; transition:0.3s; }
        .btn:hover { background:#ff4757; transform:scale(1.05); }

        .about-course { display:flex; flex-wrap:wrap; align-items:center; justify-content:space-between; margin-bottom:4rem; }
        .about-content { flex:1; min-width:280px; text-align:justify; font-size:1rem; line-height:1.6; padding-right:2rem; }
        .about-content h2 { font-size:2rem; margin-bottom:1rem; text-align:left; }
        .about-course img { flex:1; min-width:280px; max-width:500px; border-radius:15px; box-shadow:0 10px 30px rgba(0,0,0,0.1); }

        @keyframes shake { 0%,100%{transform:translate(0,0) rotate(0deg);}20%{transform:translate(-2px,2px) rotate(-1deg);}40%{transform:translate(2px,-2px) rotate(1deg);}60%{transform:translate(-2px,2px) rotate(0deg);}80%{transform:translate(2px,-1px) rotate(1deg);} }
        .shake-hover:hover { animation: shake 0.5s ease-in-out; }
        .corner-card { position:relative; overflow:hidden; border-radius:15px; padding:1.5rem; box-shadow:0 8px 20px rgba(0,0,0,0.1); transition:0.3s; text-align:center; display:flex; flex-direction:column; align-items:center; }
        .corner-card::before, .corner-card::after { content:''; position:absolute; width:30px; height:30px; border:3px solid #9333ea; }
        .corner-card::before { top:0; left:0; border-right:none; border-bottom:none; }
        .corner-card::after { bottom:0; right:0; border-left:none; border-top:none; }
        .corner-card:hover { transform:translateY(-8px) scale(1.02); box-shadow:0 15px 25px rgba(0,0,0,0.2); }

        .faq-section { background:#e0e7ff; padding:4rem 1rem; }
        .faq-card { margin-bottom:1rem; cursor:pointer; }

      `}</style>

      {/* Hero */}
      <header className="hero-section" data-aos="fade-down">
        <div className="container">
          <h1 className="animate-float">AI & ML Mastery</h1>
          <p>
            Master artificial intelligence and machine learning techniques for
            real-world applications
          </p>
          <Link to="/contact" className="btn">
            Enroll Now
          </Link>
        </div>
      </header>

      {/* About Section */}
      <section
        className="about-course"
        data-aos="fade-up"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2rem",
          flexWrap: "wrap",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "2rem 1rem",
        }}
      >
        {/* Image on the left */}
        <img
          className="shake-hover"
          src="/assets/computer-science-ai-machine-learning.jpg"
          alt="AI & ML Course"
          style={{
            width: "45%",
            minWidth: "300px",
            borderRadius: "15px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          }}
        />

        {/* Content on the right */}
        <div style={{ width: "50%", minWidth: "300px", textAlign: "justify" }}>
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
            }}
            data-aos="fade-up"
          >
            About This AI & ML Course
          </h2>
          <p
            style={{
              fontSize: "0.95rem",
              lineHeight: "1.7",
              textAlign: "justify",
            }}
          >
            This AI & Machine Learning course provides a comprehensive
            understanding of modern AI and ML techniques. You will learn
            essential algorithms for supervised and unsupervised learning, deep
            learning, and neural networks. The course emphasizes hands-on
            practice using Python, TensorFlow, Keras, and PyTorch through
            real-world projects and case studies. Advanced topics like natural
            language processing, model evaluation, and AI ethics are also
            covered. By the end, you will be able to confidently design, build,
            and deploy AI & ML solutions for real-world problems.
          </p>
        </div>

        {/* Responsive CSS */}
        <style jsx>{`
          @media (max-width: 768px) {
            .about-course {
              flex-direction: column; /* stack image and content */
              gap: 1.5rem;
              text-align: center;
            }

            .about-course img {
              width: 90% !important;
              min-width: unset;
            }

            .about-course div {
              width: 95% !important;
              min-width: unset;
              text-align: center !important;
            }
          }
        `}</style>
      </section>

      {/* Syllabus */}
      <section className="course-syllabus" data-aos="fade-up">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Course Syllabus
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {syllabus.map((mod, idx) => (
              <div
                key={idx}
                className="corner-card animate-shake"
                data-aos="zoom-in"
                data-aos-delay={idx * 100}
                style={{
                  background: syllabusColors[idx % syllabusColors.length],
                }}
              >
                <h3>{mod.title}</h3>
                <ul>
                  {mod.topics.map((t, i) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools */}
      <section className="tools-technologies" data-aos="fade-up">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Tools & Technologies
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {tools.map((tool, idx) => (
              <div
                key={idx}
                className="corner-card animate-float"
                data-aos="flip-left"
                data-aos-delay={idx * 50}
                style={{ background: toolColors[idx % toolColors.length] }}
              >
                <div
                  style={{ fontSize: "2rem", margin: "0 auto 10px auto" }}
                  className="animate-shake"
                >
                  {" "}
                  {tool.icon}
                </div>
                <h3>{tool.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learners */}
      <section className="who-can-enroll" data-aos="fade-up">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Who Can Enroll
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {learners.map((learner, idx) => (
              <div
                key={idx}
                className="corner-card animate-wiggle"
                data-aos="fade-right"
                data-aos-delay={idx * 50}
                style={{
                  background: learnerColors[idx % learnerColors.length],
                }}
              >
                <div
                  style={{ fontSize: "2rem", margin: "0 auto 10px auto" }}
                  className="animate-bounce-slow"
                >
                  {learner.icon}
                </div>
                <h3>{learner.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Careers */}
      <section className="career-opportunities" data-aos="fade-up">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Career Opportunities
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {careers.map((career, idx) => (
              <div
                key={idx}
                className="corner-card animate-pulse"
                data-aos="fade-left"
                data-aos-delay={idx * 50}
                style={{ background: careerColors[idx % careerColors.length] }}
              >
                <div
                  style={{ fontSize: "2rem", margin: "0 auto 10px auto" }}
                  className="animate-bob"
                >
                  {career.icon}
                </div>
                <h3>{career.title}</h3>
                <p>{career.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Outcomes */}
      <section
        className="learning-outcomes"
        data-aos="fade-up"
        style={{ padding: "2rem 0" }}
      >
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            What You'll Learn
          </h2>

          <div
            style={{ overflow: "hidden", width: "100%", position: "relative" }}
          >
            <div
              className="marquee-track"
              style={{
                display: "flex",
                gap: "1rem",
                animation: "marqueeLTR 25s linear infinite",
              }}
            >
              {[...outcomes, ...outcomes].map((o, idx) => (
                <div
                  key={idx}
                  className="outcome-card p-5"
                  style={{
                    minWidth: "220px",
                    flexShrink: 0,
                    background: "#fdf6f0",
                    borderRadius: "15px",
                    textAlign: "center",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="animate-wiggle"
                    style={{
                      fontSize: "2rem",
                      margin: "0 auto 10px auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      border: "3px solid #2575fc",
                      color: "#2575fc",
                    }}
                  >
                    {o.icon}
                  </div>
                  <h3 className="pt-2">{o.title}</h3>
                  <p>{o.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style>{`
    @keyframes marqueeLTR {
      0% { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }
    .marquee-track:hover {
      animation-play-state: paused;
    }
  `}</style>
      </section>

      {/* FAQ */}
      <section className="faq-section" data-aos="fade-up">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              marginBottom: "1.2rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Frequently Asked Questions
          </h2>
          {faq.map((q, idx) => (
            <div
              key={idx}
              className="faq-card corner-card shake-hover"
              onClick={() => toggleFaq(idx)}
              style={{ background: faqColors[idx % faqColors.length] }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>{q.question}</h3>
                {faqOpen[idx] ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {faqOpen[idx] && <p className="faq-answer open">{q.answer}</p>}
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          background: "#111",
          color: "#fff",
          padding: "4rem 1rem",
          textAlign: "center",
        }}
      >
        <div
          className="container"
          style={{ maxWidth: "1200px", margin: "0 auto" }}
        >
          <h2 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>
            Enroll Now to Kickstart Your AI & ML Career
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "2rem",
              lineHeight: "1.6",
              maxWidth: "700px",
              margin: "0 auto",
            }}
          >
            Join our comprehensive AI & ML program and gain hands-on experience
            with real-world projects, cutting-edge tools, and practical case
            studies to accelerate your career in artificial intelligence and
            data analytics.
          </p>
          <Link
            to="/contact"
            className="btn mt-2"
            style={{
              display: "inline-block",
              background: "#ff6b6b",
              color: "#fff",
              padding: "0.8rem 2rem",
              borderRadius: "30px",
              fontWeight: 600,
              textDecoration: "none",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#ff4757")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#ff6b6b")}
          >
            Enroll Now
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Aiml;
